export default {
    'new': 'light-grey-999',
    'in preparation': 'lemon',
    'getting quote': 'pink-lemonade',
    'needs approval': 'flamingo',
    'approved': 'yellow',
    'quote canceled': 'dark-grey-333',
    'quote rejected': 'dark-grey-333',
    'quote expired': 'dark-grey-333',
    'in progress': 'baby-blue',
    'in_progress': 'baby-blue',
    'questionwait': 'red',
    'complete': 'emerald',
    'delivered': 'mint',
    'invoiced': 'Green',
    'canceled': 'dark-grey-333',
    'deliverable': 'mint',
    'paid': 'green',
    'without invoice': 'green',
    'archived': 'green',
    '': 'yellow',
    'in review': 'purple',
    'accepted': 'lime',
    'All Feedback Submitted': 'cercise',
    'overdue': 'red',
    'pending': 'yellow',
    'active': 'green',
    'inactive': 'light-grey-999',
    'unpaid': 'yellow',
};
